import { useEffect, useState } from "react"

const JumpScareGate = ({startWebsite}) => {

    const [canView, setCanView] = useState(false);

    useEffect(()=>{
        if(localStorage.getItem('yomawari-scare-gate')) {
            setCanView(true)
            startWebsite()
        } else {
            setCanView(false)
        }
    },[])

    return (
        !canView && <div className="scare-gate">
            <img src={`${process.env.PUBLIC_URL}/img/logo-white.webp`} alt="Yomawari: Lost in the Dark" />
            <h1>This website contains jumpscares. Do you wish to continue?</h1>
            <div className="yn-container">
                <button className="yn-button" onClick={()=>{
                    localStorage.setItem('yomawari-scare-gate', true)
                    setCanView(true)
                }}>
                    YES
                </button>
                <a href="https://nisamerica.com/games/yomawari-lost-in-the-dark">
                    NO
                </a>
            </div>
        </div>
    )

}

export default JumpScareGate;